import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStoreon } from 'storeon/react';

import BlockCustomerInfo from '../../BlockCustomerInfo';
import BlockContactMethod from '../../BlockContactMethod';
import BlockDescribeProblem from '../../BlockDescribeProblem';

import Btn from "../../Btn";
import Info from "../../Info";
import axios from "axios";
import Loader from '../../Loader';

const ServiceRequestForm = ( { id, site = '' } ) => {
    const brand = site === 'sunrise' ? 'Sunrise' : 'Milgard';
    const brandPhone = site === 'sunrise' ? '1-800-SUNRISE' : '1-800-MILGARD';
    const isMilgard = site === 'milgard';
    const [serverResponse , setServerResponse] = useState('');
    const [submitForm , setSubmitForm] = useState(false);

    const methods = useForm( {
        mode: 'all',
        reValidateMode: 'onChange',
        // Default values for field array.
        defaultValues: {
            your_project: [{}],
            sms_opt_in: false,
        },
    } );
    const { errors, trigger, handleSubmit, formState, watch } = methods;

    const contactMethod = watch('contact_method');
    const mobilePhone = watch('mobile_phone');

    const isSubmitEnabled = () => {
        if (contactMethod === 'Text') {
            return formState.isValid && mobilePhone && /^[0-9]{10}$/.test(mobilePhone);
        }

        if ((mobilePhone && !/^[0-9]{10}$/.test(mobilePhone))) {
            return formState.isValid && mobilePhone && /^[0-9]{10}$/.test(mobilePhone);
        }

        return formState.isValid;
    };

    const onSubmit = ( data ) => {
        const endpointUrl = `${window.location.origin}/sr/api`;
        setSubmitForm(true);

        axios( {
            method: 'post',
            url: endpointUrl,
            data: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        } )
            .then((response) => {
                if (response.status === 200) {
                    window.location.href = `${window.location.origin}${window.location.pathname.replace( /\/+$/, '' )}/submission`;
                }
            })
            .catch( ( error ) => {
                setServerResponse(error.response.data);
                setSubmitForm(false);
                console.log( error );
            } );
    }
    const { dispatch, groups } = useStoreon( 'groups' );
    /**
     * Trigger form validation on component init.
     * This action will pre-populate errors object.
     */
    useEffect( () => {
        trigger();
    }, [trigger] );
    /**
     * Check form errors and determine if fieldset should be disabled.
     */

    useEffect( () => {
        for ( let i = 1; i < groups.length; i += 1 ) {
            const { fields: groupFields } = groups[i - 1];
            const isValid = !Object.keys( errors ).some( ( item ) => groupFields.includes( item ) );

            // Always enable the third section when Text is selected
            if (i === 2 && contactMethod === 'Text') {
                if (groups[i].disabled) {
                    dispatch('CHANGE_FIELDSET_STATE', { id: i, disabled: false });
                }
                continue;
            }

             if (i === 2 && (mobilePhone && !/^[0-9]{10}$/.test(mobilePhone))) {
                if (groups[i].disabled) {
                    dispatch('CHANGE_FIELDSET_STATE', { id: i, disabled: false });
                }
                continue;
            }

            if ( groups[i].disabled === isValid ) {
                dispatch( 'CHANGE_FIELDSET_STATE', { id: i, disabled: !isValid } );
            }
        }
    } );

    const handleChatLaunch = () => {
        const launchButton = document.getElementById('launch-chat-btn');

        if (launchButton) {
            launchButton.click();
        }
    };

    return (
        <div className={`service-request-form container`}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit( onSubmit )}>
                    <h1 className={'title-big'}>How Can We Serve You? </h1>
                    <Info styleText={'text-grey mb-none'}>
                        Please complete the form below to help us determine the best way to serve you.
                    </Info>
                    <Info styleText={'text-grey b mb-none'}>
                        NOTE: You will need your Sales Order Number (preferred) or product information
                        in order for us to review your request.
                    </Info>
                    <Info styleText={'text-grey mb-none'}>
                        Not sure how to find it? <a href="https://www.youtube.com/watch?v=FWO_d9Sqx9E" target="_blank"
                            rel="noopener noreferrer">Click here.</a>
                    </Info>
                    <Info styleText={'text-grey'}>
                        Need help right away? Try our <a
                            href="/warranty/window-and-door-care/product-care-videos" target="_blank"
                            rel="noopener noreferrer">Do-It-Yourself videos</a> for fast help with common fixes.
                    </Info>
                    <Info styleText={'text-grey'}>
                        Looking for an update on your service status? <button className="launch-chat launch-chat-link" onClick={handleChatLaunch} type='button'>Check Here</button>
                    </Info>
                    <BlockDescribeProblem index={0} idForm={id} brand={brand}/>
                    <BlockCustomerInfo index={1} showCheckbox={!isMilgard} optionText brand={brand}/>
                    <BlockContactMethod index={2}/>
                    {!isMilgard && (
                        <Info>
                            After you click Submit, you will receive an email confirmation from {brand}. A customer service
                            representative will contact you once they have reviewed the information provided.
                        </Info>
                    )}
                    <Info styleText={'covid red'}>
                        COVID-19 Update: Please note that our call center wait times may be longer due to COVID-19.
                        We highly encourage you to use our online service request tool to help expedite your service.
                        {brand} is committed to your safety and that of our employees. Our service technicians will
                        adhere to CDC guidelines for preventive care when performing their service visit.
                    </Info>
                    <Info styleText={'covid red'}>
                        If you have an illness or any symptoms related to COVID-19 we ask that you contact us at
                        {brandPhone} to reschedule your appointment.
                    </Info>
                    <Btn disabled={!isSubmitEnabled() || submitForm}>
                        <input
                            type="submit"
                            disabled={!isSubmitEnabled() || submitForm}
                            value={'Request Service'}
                        />
                    </Btn>
                    {isMilgard && (
                        <div className="info sms-consent-acknowledgement">
                            <p>
                                By providing my phone number and clicking on the &ldquo;Request Service&rdquo; button above,
                                I acknowledge and agree to the following:
                            </p>
                            <ul>
                                <li>
                                    That I am providing my express written consent for the limited purpose to
                                    receive text messages (e.g. to schedule, confirm a schedule, estimated arrival
                                    time, etc.) from MITER Brands and its affiliates and authorized third parties
                                    calling or texting on their behalf, using an automatic telephone dialing system or
                                    an artificial or prerecorded voice at the phone number I have provided and for
                                    MITER Brands to share my information with such third parties accordingly. I
                                    understand that I am providing this consent to receive such telephone calls and
                                    texts even if my telephone number is currently listed on any federal, state,
                                    local, internal, or corporate Do-Not-Call (&ldquo;DNC&rdquo;) Lists. Message and
                                    data rates may apply. Message frequency varies. Unsubscribe at any time by
                                    replying &ldquo;STOP&rdquo;.
                                </li>
                                <li>
                                    I understand that I do not have to agree to receive these types of calls or text
                                    messages as a condition of receiving service. I understand that instead of
                                    providing consent, I may call <a href="tel:8006454273">800-645-4273</a> to speak
                                    with an individual customer care representative.
                                </li>
                            </ul>
                            <p>
                                By submitting this form, I acknowledge and agree to the MITER Brands{' '}
                                <a href="/content/privacy-notice" target="_blank" rel="noopener noreferrer">Privacy Notice</a>
                                {' '}and{' '}
                                <a href="/content/terms-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>,
                                except as restricted by this limited purpose consent.
                            </p>
                        </div>
                    )}
                    {serverResponse &&  <div className="server-error">{ serverResponse }</div>}
                </form>
            </FormProvider>
            {submitForm && <Loader />}
        </div>
    );
};

export default ServiceRequestForm;
